import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseImg from './HseImg.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseImg;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Img",class:( _obj = {}, _obj[("hse-Img_description-variant_" + _vm.descriptionVariant)] = _vm.descriptionVariant, _obj['hse-Img_hasMargin'] =  _vm.hasMargin, _obj )},[_c('img',_vm._b({staticClass:"hse-Img__img",class:_vm.classes.img},'img',_vm.$attrs,false)),_vm._v(" "),_c('div',{staticClass:"hse-Img__description",class:_vm.classes.description},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
